function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 0.500005C10 0.307802 9.88983 0.132613 9.71659 0.0493531C9.54336 -0.0339069 9.33774 -0.0104977 9.18765 0.10957L4.32461 4H0.5C0.223858 4 0 4.22386 0 4.5V10.5C0 10.7761 0.223858 11 0.5 11H4.32461L9.18765 14.8904C9.33774 15.0105 9.54336 15.0339 9.71659 14.9507C9.88983 14.8674 10 14.6922 10 14.5V0.500005ZM4.81235 4.89044L9 1.54032V13.4597L4.81235 10.1096C4.72369 10.0386 4.61354 10 4.5 10H1V5H4.5C4.61354 5 4.72369 4.96136 4.81235 4.89044Z",
  fill: "#BABABA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.819 5.04497C13.6063 4.8688 13.2912 4.89836 13.115 5.111C12.9388 5.32365 12.9684 5.63885 13.181 5.81502C13.7207 6.26218 14 6.84614 14 7.43C14 8.01386 13.7207 8.59781 13.181 9.04497C12.9684 9.22115 12.9388 9.53635 13.115 9.74899C13.2912 9.96163 13.6063 9.9912 13.819 9.81502C14.5599 9.2012 15 8.34636 15 7.43C15 6.51364 14.5599 5.65879 13.819 5.04497Z",
  fill: "#BABABA"
});

var SvgIconVolumeLow = function SvgIconVolumeLow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconVolumeLow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_volume_low.7178ba21.svg";
export { ForwardRef as ReactComponent };